(function () {
  if (window.__NO_GLASS_CART_DEDUCTION_V3_SHARED__) return;
  window.__NO_GLASS_CART_DEDUCTION_V3_SHARED__ = true;

  function getMap() {
    return window.NO_GLASS_DEDUCTION_MAP || {};
  }

  function buildDoorTypeCategoryMap() {
    const out = {};
    const map = getMap();

    Object.keys(map).forEach(category => {
      const categoryMap = map[category] || {};
      Object.keys(categoryMap).forEach(doorType => {
        out[doorType] = category;
      });
    });

    return out;
  }

  function getCategoryByDoorType(doorType) {
    return buildDoorTypeCategoryMap()[doorType] || '';
  }

  function normalizePanelType(raw) {
    const text = String(raw || '').toLowerCase().trim();
    if (/full\s*view|full\s*lite/.test(text)) return 'full_lite';
    if (/3\s*\/\s*4\s*lite|3\/4\s*lite|3\s*4\s*lite|three\s*quarter\s*lite/.test(text)) {
      return 'three_quarter_lite';
    }
    return '';
  }

  function normalizeDoorSize(raw) {
    const text = String(raw || '').trim();
    const m = text.match(/\d{4,6}/);
    return m ? m[0] : '';
  }

  function normalizeDoorType(raw) {
    const text = String(raw || '').toLowerCase().trim();

    // 先支援直接 doorType 值
    if (getCategoryByDoorType(text)) return text;

    // hinged
    if (/single[\s_-]*hinged/.test(text)) return 'single_hinged';
    if (/double[\s_-]*hinged/.test(text)) return 'double_hinged';
    if (/center[\s_-]*hinged/.test(text)) return 'center_hinged';
    if (/vented[\s_-]*sidelight|venting[\s_-]*sidelight/.test(text)) return 'vented_sidelight';

    // new hinged
    if (/folding\s*door|folding[\s_-]*door|^folding$/.test(text)) return 'folding';

    // gliding
    if (/gliding\s*door\s*-\s*2\s*panels|gliding[\s_-]*2[\s_-]*panel/.test(text)) return 'gliding_2_panel';
    if (/gliding\s*door\s*-\s*3\s*panels|gliding[\s_-]*3[\s_-]*panel/.test(text)) return 'gliding_3_panel';
    if (/gliding\s*door\s*-\s*4\s*panels|gliding[\s_-]*4[\s_-]*panel/.test(text)) return 'gliding_4_panel';

    // new gliding
    if (
      /bypass\s*gliding\s*door|bypass[\s_-]*gliding[\s_-]*door|gliding[\s_-]*bypass|bypass[\s_-]*gliding/.test(text)
    ) return 'gliding_bypass';

    // fixed
    if (/fixed\s*\(?\s*gliding\s*\)?\s*-\s*1\s*panel/.test(text)) return 'gliding_one_panel';
    if (/fixed\s*-\s*1\s*panel/.test(text)) return 'hinged_one_panel';
    if (/fixed\s*-\s*2\s*panels/.test(text)) return 'hinged_two_panel';
    if (/fixed\s*-\s*3\s*panels/.test(text)) return 'hinged_three_panel';

    return text || '';
  }

  function normalizeCategory(raw) {
    const text = String(raw || '').toLowerCase().trim();
    if (/hinged/.test(text)) return 'hinged';
    if (/gliding/.test(text)) return 'gliding';
    if (/fixed/.test(text)) return 'fixed';
    if (/transom/.test(text)) return 'transom';
    return text || '';
  }

  function isNoGlass(raw) {
    return /no\s*glass/i.test(String(raw || ''));
  }

  function safeParseJson(str) {
    if (!str) return {};
    try {
      return JSON.parse(str);
    } catch (e) {
      return {};
    }
  }

  function getMergedProps(props) {
    const rawProps = props || {};
    const bssRaw =
      rawProps.__bssCustomAttrs ||
      rawProps['__bssCustomAttrs'] ||
      rawProps['properties[__bssCustomAttrs]'] ||
      '';

    const bssAttrs = safeParseJson(bssRaw);

    return {
      ...rawProps,
      ...bssAttrs
    };
  }

  function getProp(props, possibleKeys) {
    if (!props) return '';
    for (const key of possibleKeys) {
      if (props[key] != null && props[key] !== '') return props[key];
    }
    return '';
  }

  function getCartItemDeductionFromProperties(rawProps) {
    if (!rawProps) return 0;

    const props = getMergedProps(rawProps);

    const doorType = normalizeDoorType(getProp(props, [
      'No Glass Door Type',
      ' No Glass Door Type',
      'Door Type',
      ' Door Type'
    ]));

    const category =
      normalizeCategory(getProp(props, [
        'No Glass Category',
        ' No Glass Category'
      ])) || getCategoryByDoorType(doorType);

    const size = normalizeDoorSize(getProp(props, [
      'No Glass Door Size',
      ' No Glass Door Size',
      'Door Size',
      ' Door Size'
    ]));

    const panelType = normalizePanelType(getProp(props, [
      'No Glass Panel Type',
      ' No Glass Panel Type',
      'Panel Type',
      ' Panel Type'
    ]));

    const noGlassSelected = getProp(props, [
      'No Glass Selected',
      ' No Glass Selected'
    ]);

    const noGlassDeductionRaw = getProp(props, [
      'No Glass Deduction',
      ' No Glass Deduction'
    ]);

    const directDeduction = parseFloat(String(noGlassDeductionRaw || '').replace(/[^0-9.-]/g, ''));
    if (/yes/i.test(String(noGlassSelected || '')) && Number.isFinite(directDeduction)) {
      return Math.abs(directDeduction);
    }

    const glassKey = Object.keys(props).find(k => /glass option/i.test(k));
    const glassVal = glassKey ? props[glassKey] : '';
    const hasNoGlass = /yes/i.test(String(noGlassSelected || '')) || isNoGlass(glassVal);

    if (!hasNoGlass) return 0;
    if (!category || !doorType || !size || !panelType) return 0;

    return Number(
      getMap()?.[category]?.[doorType]?.[size]?.[panelType] || 0
    );
  }

  function formatMoney(n) {
    return `$${Number(n || 0).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })}`;
  }

  function findCartRows() {
    return Array.from(document.querySelectorAll('tr.cart-item, .cart-item'));
  }

  function getRowPropertiesText(row) {
    const details = row.querySelector('.cart-item__details') || row;
    return details.innerText || '';
  }

  function getRowTitleText(row) {
    return (
      row.querySelector('.cart-item__name')?.textContent ||
      row.querySelector('.cart-item__details a')?.textContent ||
      row.querySelector('.cart-item__details')?.textContent ||
      ''
    ).trim();
  }

  function detectDoorMetaFromRowText(text, titleText) {
    const raw = `${String(titleText || '')}\n${String(text || '')}`;

    let doorType = normalizeDoorType(raw);
    let category = getCategoryByDoorType(doorType);
    let size = '';
    let panelType = '';

    const sizeMatch = raw.match(/door\s*size\s*:\s*(\d{4,6})/i) || raw.match(/\b(\d{4,6})\b/);
    if (sizeMatch) size = sizeMatch[1];

    if (/full\s*view|full\s*lite/i.test(raw)) {
      panelType = 'full_lite';
    } else if (/3\s*\/\s*4\s*lite|3\/4\s*lite|3\s*4\s*lite|three\s*quarter\s*lite/i.test(raw)) {
      panelType = 'three_quarter_lite';
    }

    const hasNoGlass =
      /no\s*glass/i.test(raw) ||
      /glass\s*option[\s\S]*no\s*glass/i.test(raw);

    return { category, doorType, size, panelType, hasNoGlass };
  }

  async function fetchCart() {
    try {
      const r = await fetch('/cart.js?_=' + Date.now(), {
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json', 'Cache-Control': 'no-cache' }
      });
      if (!r.ok) return null;
      return await r.json();
    } catch (e) {
      return null;
    }
  }

  function getRowDeduction(row, cartItem) {
    // 1) 優先吃 cart item properties
    if (cartItem?.properties) {
      const fromProps = getCartItemDeductionFromProperties(cartItem.properties);
      if (fromProps > 0) return fromProps;
    }

    // 2) 備援：從 row 文字抓
    const text = getRowPropertiesText(row);
    const titleText = getRowTitleText(row);
    const meta = detectDoorMetaFromRowText(text, titleText);

    if (!meta.hasNoGlass) return 0;
    if (!meta.category || !meta.doorType || !meta.size || !meta.panelType) return 0;

    return Number(
      getMap()?.[meta.category]?.[meta.doorType]?.[meta.size]?.[meta.panelType] || 0
    );
  }

  async function renderCartRowDeduction() {
    const rows = findCartRows();
    const cart = await fetchCart();
    const items = cart?.items || [];

    rows.forEach((row, idx) => {
      const cartItem = items[idx] || null;
      const deduction = getRowDeduction(row, cartItem);

      row.style.position = 'relative';

      let line = row.querySelector('.no-glass-cart-credit');

      if (!line) {
        line = document.createElement('div');
        line.className = 'no-glass-cart-credit';
        line.style.position = 'absolute';
        line.style.right = '0';
        line.style.bottom = '30px';
        line.style.color = '#c62828';
        line.style.fontWeight = '700';
        line.style.fontSize = '14px';
        line.style.textAlign = 'right';
        line.style.whiteSpace = 'nowrap';
        row.appendChild(line);
      }

      if (deduction > 0) {
        line.textContent = `No Glass Deduction: -${formatMoney(deduction)}`;
        line.style.display = '';
      } else {
        line.style.display = 'none';
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(renderCartRowDeduction, 400);
    setTimeout(renderCartRowDeduction, 1200);
    setTimeout(renderCartRowDeduction, 2200);
  });

  async function getNoGlassCartDeductionTotal() {
    const rows = findCartRows();
    const cart = await fetchCart();
    const items = cart?.items || [];

    return rows.reduce((sum, row, idx) => {
      const deduction = getRowDeduction(row, items[idx] || null);
      return sum + (Number(deduction) || 0);
    }, 0);
  }

  window.getCartItemDeductionFromProperties = getCartItemDeductionFromProperties;
  window.renderCartRowDeduction = renderCartRowDeduction;
  window.getNoGlassCartDeductionTotal = getNoGlassCartDeductionTotal;
  window.getNoGlassCategoryByDoorType = getCategoryByDoorType;
})();